import { useDispatch } from "react-redux";
import { signInUser, setFirebaseToken } from "features/user/userSlice";
import { serializeFirebaseUser, sleep } from "utils/helpers";
import { useFetchProfile, useFetchConsentForProfile, useSubscribeToOffers } from "hooks";

export default function useProcessSocialSignInResponse() {
  const dispatch = useDispatch();
  const { fetchProfile } = useFetchProfile();
  const { fetchConsentForProfile } = useFetchConsentForProfile();
  const { subscribeToOffers } = useSubscribeToOffers();

  const processSocialSignInResponse = async (
    firebaseToken,
    authUser,
    isSignUp = false,
    subscribeOffers = false
  ) => {
    // Wait for all async logic before dispatching signInUser (which may redirect or change state)
    if (firebaseToken) {
      dispatch(setFirebaseToken(firebaseToken));
      await sleep(500); // need to wait for Firebase to associate firebase token (gotten from exchanging OAuth token) to user
      const profileData = await fetchProfile(firebaseToken);
      fetchConsentForProfile(firebaseToken, profileData?.id);
      if (isSignUp && subscribeOffers) {
        // If it's a sign-up and the user wants to subscribe to offers
        const result = await subscribeToOffers(firebaseToken, profileData?.id);
        if (!result.success) {
          console.error("Failed to subscribe to offers:", result.error);
        }
      }
    }

    if (authUser) {
      dispatch(signInUser(serializeFirebaseUser(authUser)));
    }
  };

  return { processSocialSignInResponse };
}
